module.exports = __webpack_public_path__ + "static/media/signage.fa1ac7b1.svg";